import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconNetwork({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="b" d="M0 0h1.72v13.636H0z" />
				<path
					id="d"
					d="M4.113 0H3.08a.12.12 0 0 0-.12.123V4.57c0 .068.053.124.12.124h1.034c.066 0 .12-.056.12-.124V.123A.12.12 0 0 0 4.113 0M1.275.123V4.57a.12.12 0 0 1-.12.124H.12A.12.12 0 0 1 0 4.57V.123C0 .055.054 0 .12 0h1.035c.066 0 .12.055.12.123"
				/>
				<filter
					id="a"
					width="129.9%"
					height="121.5%"
					x="-15%"
					y="-5.4%"
					filterUnits="objectBoundingBox"
				>
					<feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
					<feGaussianBlur
						in="shadowOffsetOuter1"
						result="shadowBlurOuter1"
						stdDeviation={0.5}
					/>
					<feColorMatrix
						in="shadowBlurOuter1"
						result="shadowMatrixOuter1"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
					/>
					<feMerge>
						<feMergeNode in="shadowMatrixOuter1" />
						<feMergeNode in="SourceGraphic" />
					</feMerge>
				</filter>
			</defs>
			<g
				fill="none"
				fillRule="evenodd"
				filter="url(#a)"
				transform="translate(5.272 3.07)"
			>
				<path
					fill="#CD0400"
					d="M9.12 2.63H8.085a.12.12 0 0 0-.12.124v4.447c0 .069.054.124.12.124H9.12c.066 0 .12-.055.12-.124V2.754a.12.12 0 0 0-.12-.123m-2.839.123v4.447a.12.12 0 0 1-.12.124H5.126a.12.12 0 0 1-.12-.124V2.754c0-.068.054-.123.12-.123h1.035c.067 0 .12.055.12.123"
				/>
				<g transform="translate(6.291 5.007)">
					<mask id="c" fill="#fff">
						<use xlinkHref="#b" />
					</mask>
					<path
						fill="#CD0400"
						d="M.86 0a.12.12 0 0 0-.12.117L0 13.505a.13.13 0 0 0 .033.092.12.12 0 0 0 .087.04H1.6a.12.12 0 0 0 .088-.04.13.13 0 0 0 .032-.092L.98.117A.12.12 0 0 0 .86 0"
						mask="url(#c)"
					/>
				</g>
				<path
					fill="#CD0400"
					d="M10.432 1.628a4 4 0 0 0-.189-.205.204.204 0 0 0-.294.003l-.043.045a.22.22 0 0 0 .003.307l.019.02q.084.088.164.18a3.92 3.92 0 0 1-.164 5.233l-.001.001a.22.22 0 0 0-.003.308l.043.044a.204.204 0 0 0 .294.003l.006-.007q.094-.097.182-.2c1.4-1.633 1.394-4.105-.017-5.732"
				/>
				<path
					fill="#CD0400"
					d="M11.757.264q-.082-.09-.166-.179l-.023-.023a.206.206 0 0 0-.296.002l-.042.043a.22.22 0 0 0 .002.308l.02.02q.085.088.165.178c1.952 2.188 1.958 5.568.017 7.763a6 6 0 0 1-.182.198l-.002.001a.22.22 0 0 0-.002.308l.042.043a.205.205 0 0 0 .296.002l.005-.005q.095-.097.183-.197c2.128-2.389 2.122-6.08-.017-8.462m-8.32 1.533.02-.02a.22.22 0 0 0 .003-.306l-.044-.045a.204.204 0 0 0-.294-.003l-.024.025a4 4 0 0 0-.165.18c-1.41 1.627-1.416 4.099-.016 5.733q.087.101.181.2l.006.006c.081.083.213.08.294-.003l.044-.045a.22.22 0 0 0-.003-.307l-.002-.001a3.92 3.92 0 0 1 0-5.414"
				/>
				<path
					fill="#CD0400"
					d="M1.93 8.376C-.01 6.181-.003 2.802 1.949.613a6 6 0 0 1 .185-.198.22.22 0 0 0 .002-.308L2.093.064a.206.206 0 0 0-.296-.002 6 6 0 0 0-.189.202C-.53 2.644-.536 6.337 1.592 8.726q.089.1.182.197l.005.005a.205.205 0 0 0 .296-.002l.042-.043a.22.22 0 0 0-.002-.308l-.001-.001a6 6 0 0 1-.183-.198"
				/>
				<g transform="translate(4.538 2.148)">
					<mask id="e" fill="#fff">
						<use xlinkHref="#d" />
					</mask>
					<use xlinkHref="#d" fill="#FFF" />
					<path
						fill="#CD0400"
						d="m20.725-.801-6.091.936h.001l-1.256.192-6.091.936h.001l-1.256.193-6.09.936-1.256.193-6.09.936-.287.399 6.765-1.04.581-.089 6.765-1.039.58-.089 6.766-1.04.58-.089 6.766-1.04m-4.916-1.533-4.929.757v.001L8.851-.91l-4.929.757v.001L1.505.219l-4.929.757h.001l-2.418.372-.287.399 3.093-.475h-.001L1.218.618v.001L4.311.143H4.31L8.564-.51l3.092-.475v-.001l4.254-.653m3.76.033-4.254.654-3.093.475h.001L8.07.177 4.978.652l-4.254.654-3.092.475-4.254.653-.287.4 4.929-.758 2.417-.371L5.366.948 7.783.576l4.929-.757h-.001l2.417-.372 4.93-.757M21.199.092l-6.765 1.04-.581.089-6.765 1.04-.581.089-6.765 1.039-.58.09-6.766 1.039-.58.09-.288.399 1.256-.193 6.09-.936L.13 3.685l6.09-.936 1.256-.193 6.09-.935 1.256-.194 6.09-.935m.287.506-6.765 1.039-.581.09-6.765 1.039-.581.089-6.765 1.04-.58.089-6.766 1.04-.58.089-.288.399 1.256-.192 6.09-.936L.13 4.59l6.09-.935 1.256-.193 6.09-.936 1.256-.193 6.09-.936m.287.506-6.765 1.04-.581.089-6.765 1.04-.581.089L-.258 5.2l-.58.09-6.766 1.039-.58.09-.288.399 1.256-.193 6.09-.936L.13 5.496l6.09-.936 1.256-.193 6.09-.935 1.256-.194 6.09-.935"
						mask="url(#e)"
					/>
				</g>
				<path
					fill="#FFF"
					d="M6.683 4.524a.12.12 0 0 0-.12.117l-.74 13.389a.13.13 0 0 0 .032.092.12.12 0 0 0 .088.038h1.48a.12.12 0 0 0 .087-.038.13.13 0 0 0 .033-.092l-.74-13.39a.12.12 0 0 0-.12-.116"
				/>
			</g>
		</svg>
	);
}
